module.exports = __webpack_public_path__ + "static/img/f101.9dbe713b.png";